import { PopperPlacementType } from "@material-ui/core/Popper";
import {
  Menu,
  Modal,
  Typography,
  WebMenuItem,
} from "@thingsw/pitta-design-system";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReferenceObject } from "../types";

import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../features/store";
import { logout, USER } from "../features/User/slice";
import { PAYMENT } from "../features/Payment/slice";
import { getPlanFromServiceID } from "../utils/Service";
import { useHistory } from "react-router-dom";
import { Pricing } from "./Pricing";
import { LightColors, UserNames } from "@thingsw/pitta-modules";

interface ProfileMenuProps {
  open: boolean;
  onCloseMenu: () => void;

  anchorEl?: null | ReferenceObject | (() => ReferenceObject);
  onClickAway: React.MouseEventHandler<Document>;

  /**
   * Popper placement.
   */
  placement?: PopperPlacementType;
}

const useStyles = makeStyles((theme: Theme) => ({
  appIcon: {
    fontSize: 15,
    color: LightColors.secondary["17"],
    marginRight: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  userInfoDiv: {
    display: "flex",
    flexDirection: "column",
    padding: "6px 16px",
    ...(theme.direction === "rtl" && { direction: "rtl" }),
  },
  webModalContent: {
    justifyContent: "center",
    padding: 0,
  },
}));

export const ProfileMenu = (props: ProfileMenuProps) => {
  const { onCloseMenu, ...restProps } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();

  const userProfile = useSelector(
    (state: RootState) => state[USER].userProfile
  );
  const subscriptionInfo = useSelector(
    (state: RootState) => state[PAYMENT].subscriptionInfo
  );

  const [planName, setPlanName] = useState<string>();
  const [openPricing, setOpenPricing] = useState(false);

  useEffect(() => {
    if (subscriptionInfo) {
      setPlanName(getPlanFromServiceID(subscriptionInfo.servicePlanID));
    }
  }, [subscriptionInfo]);

  return (
    <>
      <Menu
        {...restProps}
        modifiers={{
          preventOverflow: { enabled: false },
          flip: { enabled: false },
        }}
        style={{ zIndex: 101 }}
        dense
      >
        <div className={classes.userInfoDiv}>
          <Typography category="Default" variant="Body">
            {userProfile?.firstName} {userProfile?.lastName}
          </Typography>
          <Typography
            category="Default"
            variant="Small"
            htmlColor={LightColors.primary["2"]}
          >
            {userProfile?.email}
          </Typography>
          {/* Payment method : oneplan */}
          {subscriptionInfo?.paymentMethod === "oneplan" ? (
            <Typography
              category="Default"
              variant="Body"
              htmlColor={LightColors.primary["7"]}
            >
              {t("One Plan")}
            </Typography>
          ) : (
            <Typography
              category="Default"
              variant="Small"
              htmlColor={LightColors.primary["2"]}
            >
              {t(planName ?? "")}
              {planName === "Fleet plan" &&
                userProfile?.userType &&
                ` · ${t(UserNames[userProfile.userType])}`}
            </Typography>
          )}          
        </div>
        <Divider className={classes.divider} />
        <WebMenuItem
          onClick={() => {
            history.push("/account");
            onCloseMenu();
          }}
          dense
        >
          {t("Account")}
        </WebMenuItem>
        <WebMenuItem
          onClick={() => {
            history.push("/account/settings");
            onCloseMenu();
          }}
          dense
        >
          {t("Settings")}
        </WebMenuItem>

        <WebMenuItem
          endIcon={<CardGiftcardIcon className={classes.appIcon} />}
          onClick={() => {
            setOpenPricing(true);
            onCloseMenu();
          }}
          disabled={planName === "Fleet plan" || subscriptionInfo?.paymentMethod === "oneplan"}
          dense
        >
          {t("Upgrade")}
        </WebMenuItem>

        <WebMenuItem onClick={() => dispatch(logout())} dense>
          {t("Log out")}
        </WebMenuItem>
      </Menu>
      <Modal
        open={openPricing}
        content={<Pricing modal onClose={() => setOpenPricing(false)} />}
        close
        onClose={() => setOpenPricing(false)}
        contentClassName={classes.webModalContent}
        fullSize
      />
    </>
  );
};
